import utils from './utils.js';
import EmapFlowToolbar from './components/emap-flow-toolbar.vue';
import EmapmAvatarUpload from './components/emapm-avatar-upload.vue';
import EmapmForm from './components/emapm-form/emapm-form.vue';
import EmapmUploadImgs from './components/emapm-upload-imgs.vue';
const version = "1.1.78";
const description = "mobile components for EMAP";
const author = "戚雨 <yuqi@wisedu.com>";
const components = {
    EmapFlowToolbar,EmapmAvatarUpload,EmapmForm,EmapmUploadImgs
};
const install = function (Vue, opts = {}) {
    if (install.installed) return;
    Object.keys(components).forEach((key) => {
        if (key === "utils") return;
        Vue.component(components[key].name, components[key]);
    });
};
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}
if(window.MINT){
    window.mintUI = window.MINT
}
export {install, utils, version, description, author}
export default Object.assign({}, {install, ...components, utils, version, description, author});


// WEBPACK FOOTER //
// ./src/entry.js